import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import Input from './Input';
import styled from 'styled-components';
import Label from './Label';
import HelperText from './HelperText';

export const InputLayout = styled.div`
  position: relative;
`;

const InputHookForm = ({
  ariaLabel,
  helperText,
  defaultValue,
  name,
  rules,
  isDisabled,
  label,
  ...props
}) => {
  const {
    register,
    formState: { errors },
    setValue,
  } = useFormContext();

  useEffect(() => {
    setValue(name, defaultValue || null);
  }, [defaultValue, name, setValue]);

  const errorMessage = errors?.[name]?.message;

  return (
    <InputLayout>
      <Label htmlFor={name} errorMessage={errorMessage}>
        {errorMessage || label}
      </Label>
      {helperText && <HelperText>{helperText}</HelperText>}
      <Input
        {...register(name, rules)}
        disabled={isDisabled}
        errorMessage={errorMessage}
        aria-label={ariaLabel}
        {...props}
      />
    </InputLayout>
  );
};
InputHookForm.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  name: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  rules: PropTypes.object,
  helperText: PropTypes.string,
};

InputHookForm.defaultProps = {
  defaultValue: undefined,
  helperText: undefined,
  isDisabled: false,
  rules: undefined,
};

export default InputHookForm;
